import type {CommonInput} from './types';
import type {AttachmentInput} from './validators/attachment';
import {attachmentValidators} from './validators/attachment';
import {booleanValidators} from './validators/boolean';
import {commonValidators} from './validators/common';
import {numberValidators} from './validators/number';
import {stringValidators} from './validators/string';

export function validator(value: CommonInput, field: string, params: any) {
  return {
    ...commonValidators(value, field),
    ...stringValidators(value + '', field, params),
    ...numberValidators(Number(value), field, params),
    ...booleanValidators(Boolean(value), field),
    ...attachmentValidators(value as AttachmentInput, field, params),
  };
}
